import { defineComponent, h } from 'vue';

import { INTERNAL_COL_DEFINE } from '../../constants';

import type { NTable } from '../../interface';
import type { VNode } from 'vue';

interface IColGroupProps<RecordType = NTable.TDefaultRecord> {
  colWidths: readonly (string | number | undefined)[];
  columns?: readonly NTable.NColumn.IColumn<RecordType>[];
  columnCount?: number;
}

export default defineComponent<IColGroupProps>({
  name: 'ColGroup',
  props: ['colWidths', 'columns', 'columnCount'] as any,
  setup(props) {
    return () => {
      const { colWidths, columns, columnCount } = props;
      const cols: VNode[] = [];
      const length = columnCount || columns?.length;

      // Only insert col with width & additional props
      // Skip if rest col do not have any useful info
      let mustInsert = false;

      for (let i = (length as number) - 1; i >= 0; i -= 1) {
        const width = colWidths[i];
        const column = columns && columns[i];
        const additionalProps = column && (column as any)[INTERNAL_COL_DEFINE]; // @todo wtf?

        if (width || additionalProps || mustInsert) {
          const { columnType, ...restAdditionalProps } = additionalProps || {};

          cols.unshift(
            h('col', {
              key: i,
              style: { width: typeof width === 'number' ? `${width}px` : width },
              ...restAdditionalProps
            })
          );

          mustInsert = true;
        }
      }

      return h('colgroup', cols);
    };
  }
});
